"use strict";

var app = angular.module('rmFormBuilder');

class FormBuilderFormCtrl
{

    constructor ( $http , $stateParams ) {


        let csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        this.$http = $http;
        this.$stateParams = $stateParams;
        

        // Defaults
        this.formdata = {
            _token: csrftoken
        };

        this.status = {
            error: false,
            errorMessages: [],
            sending: false
        };
   
        this.fetch();
    }

    fetch(url = null)
    {     
        if (!url) {
            url = '/contacts/';
        }

        if( this.$stateParams && this.$stateParams.contactId) {
            url += this.$stateParams.contactId;
        }

        this.$http.get(url).then((response) => {

            this.formdata = response.data;
        });
    }

    submit ( isValid ) {

        if( !isValid ) {

            return;
        }

        this.status.sending = true;
        this.status.error = false;
        this.status.errorMessages.length = 0;

        //Set the right method
        var method = this.formdata.id ? 'put' : 'post';
        var url = this.formdata.id ? '/formbuilder/    '+this.formdata.id : '/formbuilder';

        this.$http[ method ](url, this.formdata)
            .then(() => {

                // Login successfull!
                this.status.sending = false;

                window.location.reload();
            })
            .catch((response) => {

                // Extract Laravel errors
                Object.getOwnPropertyNames(response.data).forEach((fieldName) => {

                    response.data[fieldName].forEach((message) => {

                        this.status.errorMessages.push(message);
                    });
                });

                this.status.error = true;
                this.status.sending = false;
            });
    }


}

module.exports = FormBuilderFormCtrl;